import { render, staticRenderFns } from "./WorkHours.vue?vue&type=template&id=55c595d9&"
import script from "./WorkHours.vue?vue&type=script&lang=js&"
export * from "./WorkHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports